/** GlobeController
 * Controls the globe and render it inside the DOM
 */

import {randomString, rem} from '../utils/utils.js';
import VideoExport from './videoExport.js';
import { ColorScale, ColorScales } from '../model/colorScales.js';
import globeProjections from '../model/globes.js';
import Globe from '../model/globe.js';
import Particles from '../model/particles.js';
import {linspace} from '../utils/utils.js';
var d3Format = require("d3-format");

/** get the library path */
var scriptEls = document.getElementsByTagName( 'script' );
var scriptPath = scriptEls[scriptEls.length - 1].src;
var scriptFolder = scriptPath.substr(0, scriptPath.lastIndexOf( '/' )+1 );
console.log( scriptFolder );
export function getLibPath() {return scriptFolder;}

export class GlobeController {
  constructor(config) {
    var scriptEls = document.getElementsByTagName( 'script' );
    var thisScriptEl = scriptEls[scriptEls.length - 1];
    var scriptPath = thisScriptEl.src;
    var scriptFolder = scriptPath.substr(0, scriptPath.lastIndexOf( '/' )+1 );

    console.log( [scriptEls, thisScriptEl, scriptPath, scriptFolder] );

    if (config.projectionName === undefined) {
      throw "Globe error : Projection name missing in config";
    }
    if (config.parentDivName === undefined) {
      throw "Globe error : Parent HTML div missing in config";
    }

    this.defaultConfig = {
      //projectionName: no default,
      //parentDivName: no default,
      //title: no default,
      allowSelection: true,
      showCore: true,
      showExport : true,
      showFullscreen : true,
      showParameters : true,
      showZoom : true,
      overlay: {
        opacity:    1,
        ///data:       null,
        colorScale: "DivRdBu",
        colorScaleInvert: false,
        logColors:  false,
        show:       true,
        unit:       "",
        unitMultiplier: 1,
        //title:      null,
        hiddenColor:"rgba(0,0,0,0.75)",
        earthSurface: false, // if true displays overlay to Earth's surface
        //min:        undefined,
        //max:        undefined
      },
      flow: {
        opacity:    1,
        //data:       null,
        colorScale: "Black",
        colorScaleData: 2, //0=θ, 1=φ, 2=Norm
        colorScaleInvert: false,
        logColors:  false,
        show:       true,
        unit:       "",
        unitMultiplier: 1,
        title:      null,
        fps:        15,
        npart:      5000,
        timestep:   0.3,
        maxage:     25/0.3,
        particleTail: 0.95,
        minParticleSize: 1,
        maxParticleSize: 5,
        earthSurface: false, // if true displays flow to Earth's surface
      },
      map: {
        opacity: 0.7,
      },
      points: {
        opacity: 1,
        show: false,
        earthSurface: false, // if true displays flow to Earth's surface
        //data: null,
      },
      export: {
        overlay:    true,
        particles:  true,
        map:        true,
        legend:     true,
        duration:   3,
        format:     "png",
        quality:    80,
        times: null,
        skiptimes: 1,
        snapshot: true,
      }
    };

    this.config = $.extend(true,{},this.defaultConfig,config);
    console.log(this.config);

    if (this.config.overlay.min) { this.manualMinOverlay = true ;}
    if (this.config.overlay.max) { this.manualMaxOverlay = true ;}
    if (this.config.overlay.center) { this.manualCenterOverlay = true ;}
    if (this.config.overlay.extent) { this.manualExtentOverlay = true ;}
    if (!this.config.overlay.data) { this.config.overlay.show = false ;}
    if (!this.config.flow.data) { this.config.flow.show = false ;}

    this.name = randomString(6); //globe unique id (in case of multiple globes)
    this.parentDiv = $(this.config.parentDivName); //HTML div container
    this.width = Math.floor(this.parentDiv.width());
    this.height = Math.floor(this.parentDiv.height());

    this.parentDiv.empty(); //clear parent div
    this.parentDiv.off();   //clear interactions if any
    this.parentDiv.addClass("globediv");
    this.parentDiv.find(".dimmer").addClass("active").find(".loader").text("Initializing globe...");

    //creating loader
    $("<div class=\"ui inverted dimmer\"><div class=\"ui indeterminate large text loader\">Loading</div></div>")
                 .appendTo(this.parentDiv);

    //creating canvases
    $("<canvas>").attr({id: this.name + "overlaycanvas"})
                 .attr({width: this.width + "px", height: this.height + "px"})
                 .css({position: "absolute", top:0, left:0, opacity:this.config.overlay.opacity})
                 .appendTo(this.parentDiv);

    $("<canvas>").attr({id: this.name + "colorflowcanvas"})
                 .attr({width: this.width + "px", height: this.height + "px"})
                 .css({position: "absolute", top:0, left:0, display:"none"})
                 .appendTo(this.parentDiv);

    $("<canvas>").attr({id: this.name + "particlescanvas"})
                 .attr({width: this.width + "px", height: this.height + "px"})
                 .css({position: "absolute", top:0, left:0, opacity:this.config.flow.opacity})
                 .appendTo(this.parentDiv);

    $("<canvas>").attr({id: this.name + "mapcanvas"})
                 .attr({width: this.width + "px", height: this.height + "px"})
                 .css({position: "absolute", top:0, left:0, opacity: this.config.map.opacity})
                 .appendTo(this.parentDiv);

    $("<canvas>").attr({id: this.name + "legendcanvas"})
                 .attr({width: this.width + "px", height: this.height + "px"})
                 .css({position: "absolute", top:0, left:0})
                 .appendTo(this.parentDiv);

     this.pointsSvg = d3.select(this.config.parentDivName)
                              .append("svg")
                              .attr("id", this.name + "pointssvg")
                              .attr("width", this.width)
                              .attr("height", this.height)
                              .style("position","absolute").style("top",0)
                              .style("left",0).style("opacity",this.config.map.opacity);

    $("<canvas>").attr({id: this.name + "rendercanvas"})
                 .attr({width: this.width + "px", height: this.height + "px"})
                 .css({position: "absolute", top:0, left:0, display:"none"})
                 .appendTo(this.parentDiv);

    //create menu div
    this.menuDiv = $("<div class=\"menudiv\"></div>")
                      .css({position: "absolute",
                        bottom: "0",left: "50%", transform:"translateX(-50%)",
                        padding: "0.5rem", margin: 0})
                      .appendTo(this.parentDiv);

    //create zoom buttons
    $("<div class=\"ui compact icon buttons\"> \
          <button class=\"ui black button zoomout\" data-tooltip=\"Zoom out\" data-inverted=\"\"><i class=\"zoom out icon\"></i></button> \
          <button class=\"ui black button resetzoom\" data-tooltip=\"Reset zoom\" data-inverted=\"\"><i class=\"search icon\"></i></button> \
          <button class=\"ui black button zoomin\" data-tooltip=\"Zoom in\" data-inverted=\"\"><i class=\"zoom icon\"></i></button> \
        </div>")
                  .attr({id: this.name + "zoombtn"})
                  .css({position: "relative",opacity:0.8,"margin-right":"0.25rem"})
                  .appendTo(this.menuDiv)
                  .toggle(this.config.showZoom);

    //create parameters button
    $("<button class=\"ui black compact icon button\" data-tooltip=\"Parameters\" data-inverted=\"\"><i class=\"options icon\"></i></button>")
                  .attr({id: this.name + "parametersbtn"})
                  .css({position: "relative",opacity:0.8})
                  .appendTo(this.menuDiv)
                  .toggle(this.config.showParameters);

    //create export video button
    $("<button class=\"ui black compact icon button\" data-tooltip=\"Export image/animation\" data-inverted=\"\"><i class=\"external share icon\"></i></button>")
                  .attr({id: this.name + "videoparametersbtn"})
                  .css({position: "relative",opacity:0.8})
                  .appendTo(this.menuDiv)
                  .toggle(this.config.showExport);

    //create full screen button
    $("<button class=\"ui black compact icon button\" data-tooltip=\"Fullscreen\" data-inverted=\"\"><i class=\"expand icon\"></i></button>")
                  .attr({id: this.name + "fullscreen"})
                  .css({position: "relative",opacity:0.8})
                  .appendTo(this.menuDiv)
                  .toggle(this.config.showFullscreen);

    //create parameter div
    $("<div class=\"ui compact inverted segment\"></div>")
                  .load(earthcorevisu.libPath + "/view/parameters.html")
                  .attr({id: this.name + "parametersdiv"})
                  .css({"text-align": "left",position: "absolute",
                    bottom: 0,left: "50%", transform:'translateX(-50%)',
                    padding: "0.5rem", margin: 0,
                    opacity:0.93})
                  .appendTo(this.parentDiv)
                  .hide();

    //create point info div
    $("<div class=\"ui compact inverted segment\"></div>")
                  .load(earthcorevisu.libPath + "/view/pointinfo.html")
                  .attr({id: this.name + "pointinfodiv"})
                  .css({"text-align": "left",position: "absolute",
                    top: 0,right: 0,
                    padding: "0.5rem", margin: 0,
                    opacity:0.93})
                  .appendTo(this.parentDiv)
                  .hide();

    //create video export div
    $("<div class=\"ui compact inverted segment\"></div>")
                  .load(earthcorevisu.libPath + "/view/videoexport.html")
                  .attr({id: this.name + "videoexportdiv"})
                  .css({"text-align": "left",position: "absolute",
                    bottom: 0,left: "50%", transform:'translateX(-50%)',
                    padding: "0.5rem", margin: 0,
                    opacity:0.93})
                  .appendTo(this.parentDiv)
                  .hide();

    //initializing globe model
    this.globe = new Globe(this.config,[this.width,this.height], this.name);
    this.setColorScale(this.config.overlay.colorScale,null,null,false);
    this.setFlowColorScale(this.config.flow.colorScale,null,null,false);
    this.initInteractions();
    this.globe.initGlobe(this.config.projectionName);

    //video export
    this.video = new VideoExport(this);

    if (this.config.overlay.data !== null) {
      this.setOverlayData(this.config.overlay.data,false);
    }
    if (this.config.flow.data !== null) {
      this.setFlowData(this.config.flow.data,false);
    }
    this.resize();

    this.parentDiv.find(".dimmer").removeClass("active");
  }

  /**
   * Clear all timeouts and intervals
   */
  clear() {
    this.globe.clearFlow();
    this.globe.clearOverlay();
    this.clearColorLegends();
    this.config.flow.data = null;
    this.config.overlay.data = null;
  }

  /**
   * Clear all timeouts and intervals
   */
  destroy() {
    clearTimeout(this.resizeTimeout);
    clearTimeout(this.globe.drawTimeout);
    clearTimeout(this.globe.drawOverlayTimeOut);
    clearInterval(this.globe.zoomInterval);
    clearInterval(this.globe.preciseDrawTimeout);
    clearInterval(this.globe.drawFlowInterval);
    $(window).off("resize", this.resizeFct);
    this.config = null;
    this.parentDiv.empty(); //clear parent div
    this.parentDiv.off();   //clear interactions if any
    this.video = null;
    this.globe = null;
  }

  /** initInteractions
   * Defines interactions of the globe with the User
   */
  initInteractions(){
    var thisGC = this;
    this.mouseDown = false;

    //ON DRAG DROP OR CLICK
    this.parentDiv.off();
    this.parentDiv.on("mousedown", function(event) {
      if (thisGC.globe.busyDrawing) {return;}
      if (thisGC.video.isRendering) {return;}
      if (event.which === 1) {
          //left click
        event.preventDefault();
        thisGC.globe.cancelDraw = true;
        thisGC.globe.mouseDown = true;
        thisGC.globe.isDragging = false;
        thisGC.globe.startMouse = [event.pageX,event.pageY];

        thisGC.globe.projection.precision(thisGC.globe.precision * 10);
        thisGC.globe.earthSurfaceProjection.precision(thisGC.globe.precision * 10);
        thisGC.globe.currentRotation = thisGC.globe.projection.rotate();
        thisGC.globe.currentTranslation = thisGC.globe.projection.translate();
      }
    });

    this.parentDiv.on("mousemove", function(event) {
      if (thisGC.globe.mouseDown) {
        var xd = event.pageX - thisGC.globe.startMouse[0];
        var yd = event.pageY - thisGC.globe.startMouse[1];

        if (!thisGC.globe.isDragging) {
          if (Math.max(Math.abs(xd),Math.abs(yd)) > 3) {
            // User moved more than 3 pixels without mouse up = drag
            thisGC.globe.isDragging = true;
            thisGC.globe.clearFlow(); //clearing flow when dragging
            //thisGC.globe.clearOverlay(false); //clearing overlay when dragging
          }
        }
        if (thisGC.globe.isDragging) { //User is dragging
          //Translate globe
          if (thisGC.globe.cantranslate) {
            var translation = [
              thisGC.globe.currentTranslation[0] + (thisGC.globe.translX ? xd : 0) ,
              thisGC.globe.currentTranslation[1] + (thisGC.globe.translY ? yd : 0),
            ];
            thisGC.globe.projection.translate(translation);
            thisGC.globe.earthSurfaceProjection.translate(translation);
            thisGC.globe.maskToUpdate = true;
          }
          //Rotates globe
          if (thisGC.globe.canrotate) {
            var sensitivity = 60 / thisGC.globe.scale;  // seems to provide a good drag scaling factor
            var rotation = thisGC.globe.projection.rotate();
            if (thisGC.globe.rotx !== null) { rotation[thisGC.globe.rotx] = xd * sensitivity  + thisGC.globe.currentRotation[0]; }
            if (thisGC.globe.roty !== null) { rotation[thisGC.globe.roty] = -yd * sensitivity  + thisGC.globe.currentRotation[1]; }
            thisGC.globe.projection.rotate(rotation);
            thisGC.globe.earthSurfaceProjection.rotate(rotation);
          }
          //Update globe
          thisGC.globe.drawMap(false,false,true);
        }
      }

    });


    this.parentDiv.on("mouseup mouseleave", function(event) {
      console.log("UP LEAVE")
      if (thisGC.globe.mouseDown) {
        thisGC.globe.mouseDown = false;
        if (!thisGC.globe.isDragging) {
          //mouse down+up without drag = click
          if ($("#" + thisGC.name + "parametersdiv").is(":visible") ||
              $("#" + thisGC.name + "videoexportdiv").is(":visible")) {
            $("#" + thisGC.name + "parametersdiv").hide();
            $("#" + thisGC.name + "videoexportdiv").hide();
            return;
          }
          if ($("#" + thisGC.name + "pointinfodiv").is(":visible")) {
            thisGC.hidePointInfo();
          }
          console.log("USER CLICKED",$("#"+ thisGC.name + "overlaycanvas"));
          var x = event.pageX - $("#"+ thisGC.name + "overlaycanvas").offset().left;
          var y = event.pageY - $("#"+ thisGC.name + "overlaycanvas").offset().top;
          if (thisGC.globe.isInsideMask(x,y)) {
            var λl = (thisGC.config.points.earthSurface ? thisGC.globe.earthSurfaceProjection.invert([x,y]) : thisGC.globe.projection.invert([x,y]));
            if (λl !== undefined) {
              thisGC.showPointInfo(λl);
            }
          }
        }
        else {
          //end drag = draw precise map;
          if (thisGC.globe.canrotate || thisGC.globe.cantranslate) {
            thisGC.globe.isDragging = false;
            thisGC.globe.projection.precision(thisGC.globe.precision);
            thisGC.globe.earthSurfaceProjection.precision(thisGC.globe.precision);
            thisGC.globe.drawMap(true);
          }
        }
      }

    });

    // Mouse Wheel Zoom
    if (thisGC.globe.canzoom) {
      this.parentDiv.on("mousewheel", function(event) {
        event.preventDefault();
        var zoomstep = (event.deltaY*event.deltaFactor)/1000 * thisGC.globe.scale;
        thisGC.zoom(zoomstep);
      });
    }


    //Zoom buttons
    $("#" + this.name + "zoombtn").find(".zoomout").off().click(function(){
      thisGC.zoom(-thisGC.globe.scale * 0.1);
    });
    $("#" + this.name + "zoombtn").find(".zoomin").off().click(function(){
      thisGC.zoom(thisGC.globe.scale * 0.1);
    });
    $("#" + this.name + "zoombtn").find(".resetzoom").off().click(function(){
      var relativeZoom = thisGC.globe.getInitScale() - thisGC.globe.scale;
      thisGC.zoom(relativeZoom);
    });

    //Parameters btn
    $("#" + this.name + "parametersbtn").off().click(function(){
      thisGC.showParameters();
    });

    //Export video btn
    $("#" + this.name + "videoparametersbtn").off().click(function(){
      thisGC.showVideoExport();
    });

    //Fullscreen btn
    $("#" + this.name + "fullscreen").off().click(function(event){
      if (!thisGC.isFullscreen) {
        thisGC.parentDiv.addClass("fullscreen");
        thisGC.isFullscreen = true;
        $(this).find(".icon").addClass("compress").removeClass("expand");
        $(this).addClass("red");
      } else {
        thisGC.parentDiv.removeClass("fullscreen");
        thisGC.isFullscreen = false;
        $(this).find(".icon").removeClass("red compress").addClass("expand");
        $(this).removeClass("red");
      }
      thisGC.resize();
    });

    this.resizeFct = this.resize.bind(this);
    $(window).resize(this.resizeFct);

    //Avoid globe interactions when clicking on buttons
    $("#" + this.name + "zoombtn, #" +
            this.name + "fullscreen, #" +
            this.name + "parametersbtn, #" +
            this.name + "videoparametersbtn")
            .off("mousedown")
            .mousedown(function(e){
              e.stopPropagation();
            });

  }

  zoom(scaleAddValue) {
    var thisGC = this;
    if (thisGC.globe.isZooming) {
      thisGC.globe.endScale = thisGC.globe.endScale + scaleAddValue;
      if ((thisGC.globe.endScale - thisGC.globe.scale) > 0) {
        thisGC.globe.scaleZoomStep = Math.max((thisGC.globe.endScale - thisGC.globe.scale) / 10,2);
      } else {
        thisGC.globe.scaleZoomStep = Math.min((thisGC.globe.endScale - thisGC.globe.scale) / 10,-2);
      }
      console.log("NEWEND",thisGC.globe.endScale);
    } else {
      thisGC.globe.clearFlow();
      thisGC.globe.clearOverlay();
      thisGC.globe.isZooming = true;
      thisGC.globe.endScale = scaleAddValue + thisGC.globe.scale;
      if ((thisGC.globe.endScale - thisGC.globe.scale) > 0) {
        thisGC.globe.scaleZoomStep = Math.max((thisGC.globe.endScale - thisGC.globe.scale) / 10,2);
      } else {
        thisGC.globe.scaleZoomStep = Math.min((thisGC.globe.endScale - thisGC.globe.scale) / 10,-2);
      }

      thisGC.globe.zoomInterval = setInterval(function(){

        var newScale = thisGC.globe.scale + thisGC.globe.scaleZoomStep;
        if (newScale >= thisGC.globe.endScale && thisGC.globe.scaleZoomStep > 0 ||
           newScale <= thisGC.globe.endScale && thisGC.globe.scaleZoomStep < 0){
          newScale = thisGC.globe.endScale;
        }
        thisGC.globe.setScale(newScale,false);
        thisGC.globe.doDrawMap(true,true);
        console.log("Zoom goal",thisGC.globe.endScale);

        if (newScale >= thisGC.globe.endScale && thisGC.globe.scaleZoomStep > 0 ||
           newScale <= thisGC.globe.endScale && thisGC.globe.scaleZoomStep < 0){
          clearInterval(thisGC.globe.zoomInterval);
          setTimeout(function(){
            thisGC.globe.maskToUpdate = true;
            thisGC.globe.drawMap(true);
            thisGC.globe.isZooming = false;
          },50);
        }

      },50);
    }

  }

  resize() {
    var thisGC = this;
    this.parentDiv.find(".dimmer").addClass("active").find(".loader").text("Resizing...");
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(function(){
      thisGC.doResize();
    },200);
  }

  doResize(){
    var thisGC = this;
    if (this.video.isRendering) {
      //Don't allow resize when video is rendering
      this.resizeTimeout = setTimeout(function(){
        thisGC.doResize();
      },200);
      return;
    }
    this.width = Math.floor(this.parentDiv.width());
    this.height = Math.floor(this.parentDiv.height());

    //RESIZING CANVASES
    $("#" + this.name + "overlaycanvas")
        .attr({width: this.width + "px", height: this.height + "px"});
    $("#" + this.name + "colorflowcanvas")
        .attr({width: this.width + "px", height: this.height + "px"});
    $("#" + this.name + "particlescanvas")
        .attr({width: this.width + "px", height: this.height + "px"});
    $("#" + this.name + "mapcanvas")
        .attr({width: this.width + "px", height: this.height + "px"});
    this.pointsSvg
        .attr("width", this.width).attr("height", this.height);
    $("#" + this.name + "legendcanvas")
        .attr({width: this.width + "px", height: this.height + "px"});
    $("#" + this.name + "rendercanvas")
        .attr({width: this.width + "px", height: this.height + "px"});

    var oldTranslation = this.globe.projection.translate();
    oldTranslation = [ oldTranslation[0] - this.globe.width / 2,
                       oldTranslation[1] - this.globe.height / 2];

    var initscale = this.globe.getInitScale();
    var currentzoom = this.globe.scale/initscale;
    var resizeRatio =  1 + ((this.width - this.globe.width)/this.globe.width + (this.height - this.globe.height)/this.globe.height )/2;

    this.globe.width = this.width;
    this.globe.height = this.height;
    this.globe.setScale(currentzoom*initscale*resizeRatio);
    var newtranslation = [this.globe.width / 2 + oldTranslation[0] * resizeRatio,
                          this.globe.height / 2 + oldTranslation[1] * resizeRatio]

    this.globe.overlayImageData = this.globe.overlayContext.createImageData(this.globe.width, this.globe.height);
    this.globe.dataOverlay = this.globe.overlayImageData.data;

    this.globe.colorflowImageData = this.globe.colorflowContext.createImageData(this.globe.width, this.globe.height);
    this.globe.dataColorflow = this.globe.colorflowImageData.data;

    this.globe.projection.scale(this.globe.scale).translate(newtranslation);
    this.globe.earthSurfaceProjection.scale(this.globe.scale*this.globe.earthSurfaceScaleRatio).translate(newtranslation);

    this.globe.mask = math.zeros([this.globe.width ,this.globe.height]);

    this.globe.maskToUpdate = true;
    this.globe.drawMap(true);
    this.drawColorLegends();

    this.parentDiv.find(".dimmer").removeClass("active");
  }

  exportVideo(save=true) {
    if ((this.config.export.timeSlider == null) || this.config.export.snapshot) {
      return this.video.captureSnapshot(save);
    } else {
      return this.video.captureTimeAnimation(this.config.export.timeSlider);
    }
  }


buildProfileChart(divname, profileData, labelData){
   var myChart = Highcharts.chart(divname, {
       chart: {
          backgroundColor : '#000000',
            type: 'line',
        },
        title: {
            text: 'Overlay profile',
          style : {color : '#707073'}
        },


     xAxis: {
       data : labelData,
       gridLineColor: '#707073',
       labels: {
          style: {
             color: '#E0E0E3'
          }
       },
       lineColor: '#707073',
       minorGridLineColor: '#505053',
       tickColor: '#707073',
       title: {
          style: {
             color: '#707073'
         }
      }
     },
     yAxis: {
       text : "Overlay value",
        gridLineColor: '#707073',
        labels: {
           style: {
              color: '#E0E0E3'
           }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: {
           style: {
              color: '#A0A0A3'
           }
        }
     },
     series: [{
          name: 'Profile',
          color : '#00FF00',
          data: profileData }]
    });
	  return myChart;
  };
  

  showPointInfo(λl) {
    if (this.config.allowSelection == false) {
      return;
    }
    var thisGC = this;
    var pointinfodiv = $("#" + thisGC.name + "pointinfodiv");
    var θφ = thisGC.globe.geoToSpher(λl);

	if (thisGC.globe.selectedPoints.length == 2){
        thisGC.globe.selectedPoints.shift();
	}
    thisGC.globe.selectedPoints.push(λl);
    // thisGC.globe.selectedPoints = [λl];
    thisGC.globe.doDrawMap(false,true); //draw map only

    pointinfodiv.off();
    pointinfodiv.mousedown(function(e){
      e.stopPropagation();
    });
    pointinfodiv.mousewheel(function(e){
      e.stopPropagation();
    });
    pointinfodiv.find(".drawprofilebtn").off().click(function(){
      // WIP
      var drawingArea = pointinfodiv.find(".profiledrawingarea");
      if (thisGC.globe.selectedPoints.length != 2){
        drawingArea.html("<b>Please, select two points before asking for a profile</b>");
        return;
      }
      console.log("button clicked");
      var pointstartλl = thisGC.globe.selectedPoints[0];
      var pointendλl = thisGC.globe.selectedPoints[1];
      var pointstartθφ = thisGC.globe.geoToSpher(pointstartλl);
      var pointendθφ = thisGC.globe.geoToSpher(pointendλl);
      drawingArea.html("<b>profile from</b>" + pointstartθφ.toString() + " to " + pointendθφ.toString());
      console.log("drawing profile from", pointstartθφ , " to ", pointendθφ);
      // get the intermediate points 
      var labeldata = [];
      var profiledata = [];
      var nbpoints = 50;
      var deltaθ =  (pointendθφ[0] - pointstartθφ[0])/nbpoints;
      var deltaφ = (pointendθφ[1] - pointstartθφ[1])/nbpoints;
      var temppoint = pointstartθφ;
      // explicitelly make a copy since ref is use else ! 
      labeldata.push([temppoint[0], temppoint[1]]);
      profiledata.push([0, thisGC.config.overlay.data.interpolateValue(temppoint)]);
      for (var i=0; i < nbpoints; i++){
        temppoint[0] += deltaθ;
        temppoint[1] += deltaφ;
        labeldata.push([temppoint[0],temppoint[1]]);
        profiledata.push([i+1, thisGC.config.overlay.data.interpolateValue(temppoint)]);
      }
      labeldata.push([pointendθφ[0],pointendθφ[1]]);
      profiledata.push([i+1, thisGC.config.overlay.data.interpolateValue(pointendθφ)]);
      // building and showing the chart
      console.log("in buildProfile chart with ", profiledata, " and ", labeldata);
      thisGC.buildProfileChart(drawingArea[0], profiledata, labeldata);
    });

    pointinfodiv.find(".longitude").text(λl[0].toFixed(2));
    pointinfodiv.find(".latitude").text(λl[1].toFixed(2));

    pointinfodiv.find(".theta").text(θφ[0].toFixed(2));
    pointinfodiv.find(".phi").text(θφ[1].toFixed(2));

    if (thisGC.config.overlay.data != null) {
      var overlaymag = thisGC.config.overlay.data.interpolateValue(θφ);
      pointinfodiv.find(".overlaymag").text(overlaymag.toFixed(2));
      pointinfodiv.find(".overlayunit").text(this.config.overlay.unit);
    }

    if (thisGC.config.flow.data != null) {
      var flow = thisGC.config.flow.data.interpolateVector(θφ);
      var flowmag = thisGC.config.flow.data.interpolateValue(θφ);
      pointinfodiv.find(".vectortheta").text((flow[0] * earthcorevisu.R_OUTER_CORE / 180 * Math.PI ).toFixed(2));
      pointinfodiv.find(".vectorphi").text(
        (flow[1] * (earthcorevisu.R_OUTER_CORE * Math.sin(θφ[0] * Math.PI / 180)) /
          180 * Math.PI).toFixed(2)
      );
      pointinfodiv.find(".vectormag").text(flowmag.toFixed(2));
      pointinfodiv.find(".vectorunit").text(this.config.flow.unit);
    }
	

    /* Show div */
    pointinfodiv.show();

    pointinfodiv.find(".close").off();
    pointinfodiv.find(".close").click(function () {
      thisGC.hidePointInfo();
    });
  }

  hidePointInfo(){
    var pointinfodiv = $("#" + this.name + "pointinfodiv");
    if (this.globe.selectedPoints.length == 2){
      this.globe.selectedPoints = [];
    }
    pointinfodiv.find(".profiledrawingarea").html("<b>Profile Area</b>");
    pointinfodiv.hide();
    this.globe.doDrawMap(false,true); //draw map only
  }

  showVideoExport(){
    var thisGC = this;
    var videoexportdiv = $("#" + this.name + "videoexportdiv");
    videoexportdiv.off();
    videoexportdiv.mousedown(function(e){
      e.stopPropagation();
    });
    videoexportdiv.mousewheel(function(e){
      e.stopPropagation();
    });

    if (!thisGC.initVideoExport) {
      thisGC.initVideoExport = true;

      /* Overlay layer checkbox */
      videoexportdiv.find(".layeroverlay.checkbox").checkbox({
        onChange: function(){
          var checked = videoexportdiv.find(".layeroverlay.checkbox").checkbox("is checked");
          thisGC.config.export.overlay = checked;
        }
      }).checkbox("set " + (thisGC.config.export.overlay ? "checked" : "unchecked"));

      /* Particles layer checkbox */
      videoexportdiv.find(".layerparticles.checkbox").checkbox({
        onChange: function(){
          var checked = videoexportdiv.find(".layerparticles.checkbox").checkbox("is checked");
          thisGC.config.export.particles = checked;
        }
      }).checkbox("set " + (thisGC.config.export.particles ? "checked" : "unchecked"));

      /* Map layer checkbox */
      videoexportdiv.find(".layermap.checkbox").checkbox({
        onChange: function(){
          var checked = videoexportdiv.find(".layermap.checkbox").checkbox("is checked");
          thisGC.config.export.map = checked;
        }
      }).checkbox("set " + (thisGC.config.export.map ? "checked" : "unchecked"));

      /* legend layer checkbox */
      videoexportdiv.find(".layerlegend.checkbox").checkbox({
        onChange: function(){
          var checked = videoexportdiv.find(".layerlegend.checkbox").checkbox("is checked");
          thisGC.config.export.legend = checked;
        }
      }).checkbox("set " + (thisGC.config.export.legend ? "checked" : "unchecked"));

      /* Video export duration */
      var videodurationvaluediv = videoexportdiv.find(".animationdurationslider").parent("div").find(".value");
      videoexportdiv.find(".animationdurationslider").off();
      videoexportdiv.find(".animationdurationslider").slider({
        value: thisGC.config.export.duration,
        min: 0,
        max: 10,
        step: 0.1,
        create: function() {
          videodurationvaluediv.text( $( this ).slider( "value" ) + 's' );
          if ($( this ).slider( "value" ) == 0) {
            videodurationvaluediv.text( "Single image" );
          }
        },
        slide: function( event, ui ) {
          if (ui.value == 0) {
            videodurationvaluediv.text( "Single image" );
          } else {
            videodurationvaluediv.text( ui.value + 's');
          }

          thisGC.config.export.duration = ui.value;
        }
      });

      /* Video quality */
      var videoqualityvaluediv = videoexportdiv.find(".videoqualityslider").parent("div").find(".value");
      videoexportdiv.find(".videoqualityslider").off();
      videoexportdiv.find(".videoqualityslider").slider({
        value: thisGC.config.export.quality,
        min: 10,
        max: 100,
        step: 1,
        create: function( event, ui ) {
          videoqualityvaluediv.text( $( this ).slider( "value" ) );
        },
        slide: function( event, ui ) {
          videoqualityvaluediv.text( ui.value );
          thisGC.config.export.quality = ui.value;
        }
      });

      /* Export Format */
      videoexportdiv.find(".exportformatdropdown")
        .dropdown({
          onChange:function(value){
            thisGC.config.export.format = value;
            if (value == "jpg" || value == "webm") {
              videoexportdiv.find(".videoqualityslider").slider("option","disabled",false);
              videoexportdiv.find(".videoqualityslider").parent(".field").show();
            } else {
              videoexportdiv.find(".videoqualityslider").slider("option","disabled",true);
              videoexportdiv.find(".videoqualityslider").parent(".field").hide();
            }
          }
        })
        .dropdown("set selected",thisGC.config.export.format);

      /* Total export duration */
      var exportintervalvaluediv = videoexportdiv.find(".exportintervalslider").parent("div").find(".value");
      videoexportdiv.find(".exportintervalslider").off();
      videoexportdiv.find(".exportintervalslider").slider({
          range:true,
          values:(thisGC.config.export.timeSlider == null ? [0,0] : [0,thisGC.config.export.timeSlider.times.length-1]),
          min: 0,
          max: (thisGC.config.export.timeSlider == null ? 0 : thisGC.config.export.timeSlider.times.length-1),
          step: 1,
          slide: function( event, ui ) {
            if (thisGC.config.export.timeSlider == null) {return;}
            var exportinterval = ((ui == null) ? videoexportdiv.find(".exportintervalslider").slider("values") : ui.values);
            var text = thisGC.config.export.timeSlider.times[exportinterval[0]] + ' - ' + thisGC.config.export.timeSlider.times[exportinterval[1]];
            exportintervalvaluediv.text( text );
          },
          change: function( event, ui ) {
            if (thisGC.config.export.timeSlider == null) {return;}
            videoexportdiv.find(".exportintervalslider").slider("option", "slide")(event, ui);

            var exportinterval = videoexportdiv.find(".exportintervalslider").slider("values");
            thisGC.config.export.ntimes = (exportinterval[1] - exportinterval[0])/thisGC.config.export.skiptimes;
            thisGC.config.export.timestoexport = [...thisGC.config.export.timeSlider.times.keys()].slice(exportinterval[0],exportinterval[1]+1)
              .filter(function(element,index){
                return (index%thisGC.config.export.skiptimes == 0);
              });

            if (thisGC.config.export.snapshot) {
              thisGC.config.export.timeSlider.setSelected(thisGC.config.export.timeSlider.getFirstSelected());
            } else {
              thisGC.config.export.timeSlider.setSelected(thisGC.config.export.timestoexport);
            }


          }
      });

      /* Skip times slider */
      var skiptimesvaluediv = videoexportdiv.find(".skiptimesslider").parent("div").find(".value");
      videoexportdiv.find(".skiptimesslider").off();
      videoexportdiv.find(".skiptimesslider").slider({
          value: thisGC.config.export.skiptimes,
          min: 1,
          max: 10,
          step: 1,
          slide: function( event, ui ) {
            if (ui.value == 1) {
              skiptimesvaluediv.text( "All" );
            } else {
              skiptimesvaluediv.text( "1 over " + ui.value);
            }
          },
          change: function( event, ui ) {
            $(this).slider("option", "slide")(event, ui);
            thisGC.config.export.skiptimes = videoexportdiv.find(".skiptimesslider").slider("value");
            videoexportdiv.find(".exportintervalslider").slider('option', 'change')();
          }
      });


      /* Total export duration */
      var exporttotaltimevaluediv = videoexportdiv.find(".exporttotaltime").parent("div").find(".value");
      videoexportdiv.find(".exporttotaltime").off();
      videoexportdiv.find(".exporttotaltime").slider({
        value: ((thisGC.config.export.totaltime == null) ? 10 : thisGC.config.export.totaltime),
        min: 0,
        max: 30,
        step: 1,
        slide: function( event, ui ) {
          if (ui.value == 0) {
            exporttotaltimevaluediv.text( "One image by date" );
          } else {
            exporttotaltimevaluediv.text( ui.value + 's');
          }
        },
        change: function( event, ui ) {
          $(this).slider("option", "slide")(event, ui);
          thisGC.config.export.totaltime = ui.value;
        }
      });

      videoexportdiv.find(".exportsnapshot.checkbox").checkbox({
        onChecked: function(){
          thisGC.config.export.snapshot = true;
          videoexportdiv.find(".exportintervalslider, .skiptimesslider, .exporttotaltime").parent(".field").hide();
          videoexportdiv.find(".animationdurationslider").parent(".field").show();
          videoexportdiv.find(".exportintervalslider").slider('option', 'change')();
        }
      }).checkbox("set " + (thisGC.config.export.snapshot ? "checked" : "unchecked"));

      videoexportdiv.find(".exporttimeanimation.checkbox").checkbox({
        onChecked: function(){
          if (thisGC.config.export.timeSlider == null) {return;}
          thisGC.config.export.snapshot = false;
          videoexportdiv.find(".animationdurationslider").parent(".field").hide();
          videoexportdiv.find(".exportintervalslider, .exporttotaltime, .skiptimesslider").parent(".field").show();
          videoexportdiv.find(".exportintervalslider").slider('option', 'change')();
        }
      }).checkbox("set " + (!(thisGC.config.export.snapshot) ? "checked" : "unchecked"));

      videoexportdiv.find(".exportvideobtn").off().click(function(){
        thisGC.exportVideo();
      });

    }

    // On show, update the fields values
    videoexportdiv.find(".animationdurationslider").slider("value",thisGC.config.export.duration);
    videoexportdiv.find(".exportvideobtn").removeClass("disabled");
    videoexportdiv.find(".cancelexportvideobtn").addClass("disabled");
    videoexportdiv.find(".downloadvideobtn").addClass("disabled");
    videoexportdiv.find(".progressloader").hide();
    videoexportdiv.find(".exportintervalslider").slider('option', 'max' , (thisGC.config.export.timeSlider == null ? 0 : thisGC.config.export.timeSlider.times.length-1));
    videoexportdiv.find(".exportintervalslider").slider('values', (thisGC.config.export.timeSlider == null ? [0,0] : [0,thisGC.config.export.timeSlider.times.length-1]));
    videoexportdiv.find(".skiptimesslider").slider('value', ((thisGC.config.export.skiptimes == null) ? 1 : thisGC.config.export.skiptimes));
    videoexportdiv.find(".exporttotaltime").slider('value', ((thisGC.config.export.totaltime == null) ? 10 : thisGC.config.export.totaltime));
    videoexportdiv.find(".exporttimeanimation.checkbox").parent(".field").toggle((thisGC.config.export.timeSlider != null));

    if ((thisGC.config.export.timeSlider == null) || thisGC.config.export.snapshot) {
      videoexportdiv.find(".exportsnapshot.checkbox").checkbox("uncheck").checkbox("check");
    } else {
      videoexportdiv.find(".exporttimeanimation.checkbox").checkbox("uncheck").checkbox("check");
    }

    /* Show div */
    videoexportdiv.show();

    videoexportdiv.find(".close").click(function () {
      videoexportdiv.hide();
    });
  }

  showParameters(){
    var thisGC = this;
    var parametersdiv = $("#" + this.name + "parametersdiv");
    parametersdiv.off();
    parametersdiv.mousedown(function(e){
      e.stopPropagation();
    });
    parametersdiv.mousewheel(function(e){
      e.stopPropagation();
    });

    if (!thisGC.initParam) {
      /* Init Accordion */

      parametersdiv.find(".ui.accordion").accordion({animateChildren:false,duration:0});

      parametersdiv.find(".showparticle").click(function(e){
        e.stopPropagation();
      });

      /* Meridian step */
      var meridian_step_label = parametersdiv.find(".meridianstepslider").parent("div").find(".value");
      parametersdiv.find(".meridianstepslider").off();
      parametersdiv.find(".meridianstepslider").slider({
        value: thisGC.globe.graticule.step()[0],
        min: 1,
        max: 180,
        create: function() {
          meridian_step_label.text( $( this ).slider( "value" ) + ' deg');
        },
        slide: function(event, ui) {
          meridian_step_label.text(ui.value + ' deg');
          thisGC.updateSteps();
        }
      });

      /* Parallel step */
      var parallel_step_label = parametersdiv.find(".parallelstepslider").parent("div").find(".value");
      parametersdiv.find(".parallelstepslider").off();
      parametersdiv.find(".parallelstepslider").slider({
        value: thisGC.globe.graticule.step()[1],
        min: 1,
        max: 90,
        create: function() {
          parallel_step_label.text( $( this ).slider( "value" ) + ' deg');
        },
        slide: function(event,ui) {
          parallel_step_label.text( ui.value + ' deg');
          thisGC.updateSteps();
        }
      });

      /* Coastline width */
      var coast_width_label = parametersdiv.find(".coastwidthslider").parent("div").find(".value");
      parametersdiv.find(".coastwidthslider").off();
      parametersdiv.find(".coastwidthslider").slider({
        value: 1.5,
        min: 0.1,
        max: 10,
        step: 0.1,
        create: function() {
          coast_width_label.text( $( this ).slider( "value" ) + ' px');
        },
        slide: function(event,ui) {
          coast_width_label.text( ui.value + ' px');
          thisGC.globe.updateCoastWidth(ui.value);
        }
      });

      /* Particule and Overlay checkboxes */
      parametersdiv.find(".showparticle").checkbox({
        onChange:function(){
          var checked = parametersdiv.find(".showparticle").checkbox("is checked");
          thisGC.config.flow.show = checked;
          if (checked) { thisGC.globe.animateFlow(); }
          else { thisGC.globe.clearFlow(); }
          thisGC.drawColorLegends();
        }
      }).checkbox("set " + (thisGC.config.flow.show ? "checked" : "unchecked"));

      parametersdiv.find(".showoverlay").click(function(e){
        e.stopPropagation();
      });
      parametersdiv.find(".showoverlay").checkbox({
        onChange:function(){
          var checked = parametersdiv.find(".showoverlay").checkbox("is checked");
          thisGC.config.overlay.show = checked;
          if (checked) { thisGC.globe.drawOverlays(true,false); }
          else { thisGC.globe.clearOverlay(false); }
          thisGC.drawColorLegends();
        }
      }).checkbox("set " + (thisGC.config.overlay.show ? "checked" : "unchecked"));

      /* List Color Scales Gradient */
      parametersdiv.find(".colorscaledropdown").find(".menu").empty();
      for (var colorScaleName in earthcorevisu.colorScales.svgGradients) {
        var dropdownitemhtml = "<div class=\"item\" data-value=\"" + colorScaleName + "\">" +
                                earthcorevisu.colorScales.svgGradients[colorScaleName].outerHTML
                                .replace(new RegExp("linear-gradient-", "g"), "linear-gradient-"+thisGC.name + "-"); +
                                "</div>";
        parametersdiv.find(".colorscaledropdown").find(".menu").append(dropdownitemhtml);
      }
      parametersdiv.find(".colorscaledropdown")
        .dropdown("set selected",thisGC.config.overlay.colorScale)
        .dropdown({
          onChange:function(value){
              //FIX svg id
            $(this).find(".text").find("linearGradient").attr("id","linear-gradient-"+thisGC.name+"-selected");
            $(this).find(".text").find("rect").attr("fill","url(#linear-gradient-"+thisGC.name+"-selected)");
            thisGC.setColorScale(value);
            thisGC.showParameters();
          }
        });

      /* Overlay Scale limits */
      parametersdiv.find(".minoverlay.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".minoverlay.checkbox").checkbox("is checked");
          thisGC.manualMinOverlay = checked;
          parametersdiv.find(".minoverlay .input").toggleClass("disabled",!checked);
          thisGC.config.overlay.min = (checked ? +parametersdiv.find(".minoverlayinput").val() / thisGC.config.overlay.unitMultiplier : null);
          thisGC.setColorScaleDomain();
        }
      }).checkbox("set " + (thisGC.manualMinOverlay ? "checked" : "unchecked"));

      parametersdiv.find(".maxoverlay.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".maxoverlay.checkbox").checkbox("is checked");
          thisGC.manualMaxOverlay = checked;
          parametersdiv.find(".maxoverlay .input").toggleClass("disabled",!checked);
          thisGC.config.overlay.max = (checked ? +parametersdiv.find(".maxoverlayinput").val() / thisGC.config.overlay.unitMultiplier: null);
          thisGC.setColorScaleDomain();
        }
      }).checkbox("set " + (thisGC.manualMaxOverlay ? "checked" : "unchecked"));

      parametersdiv.find(".minoverlay .input .button").click(function(){
        var minOverlay = +parametersdiv.find(".minoverlayinput").val() / thisGC.config.overlay.unitMultiplier ;
        thisGC.config.overlay.min = minOverlay;
        thisGC.setColorScaleDomain();
      });

      parametersdiv.find(".maxoverlay .input .button").click(function(){
        var maxOverlay = +parametersdiv.find(".maxoverlayinput").val() / thisGC.config.overlay.unitMultiplier ;
        thisGC.config.overlay.max = maxOverlay;
        thisGC.setColorScaleDomain();
      });

      parametersdiv.find(".centeroverlay.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".centeroverlay.checkbox").checkbox("is checked");
          thisGC.manualCenterOverlay = checked;
          parametersdiv.find(".centeroverlay .input").toggleClass("disabled",!checked);
          thisGC.config.overlay.center = (checked ? +parametersdiv.find(".centeroverlayinput").val() / thisGC.config.overlay.unitMultiplier : null);
          parametersdiv.find(".centeroverlay .input .button").trigger("click");
        }
      }).checkbox("set " + (thisGC.manualCenterOverlay ? "checked" : "unchecked"));

      parametersdiv.find(".extentoverlay.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".extentoverlay.checkbox").checkbox("is checked");
          thisGC.manualExtentOverlay = checked;
          parametersdiv.find(".extentoverlay .input").toggleClass("disabled",!checked);
          thisGC.config.overlay.extent = (checked ? +parametersdiv.find(".extentoverlayinput").val() / thisGC.config.overlay.unitMultiplier : null);
          parametersdiv.find(".extentoverlay .input .button").trigger("click");
        }
      }).checkbox("set " + (thisGC.manualExtentOverlay ? "checked" : "unchecked"));

      parametersdiv.find(".centeroverlay .input .button, .extentoverlay .input .button").click(function(){
        thisGC.config.overlay.center = (thisGC.manualCenterOverlay ? +parametersdiv.find(".centeroverlayinput").val() / thisGC.config.overlay.unitMultiplier : null);
        thisGC.config.overlay.extent = (thisGC.manualExtentOverlay ? +parametersdiv.find(".extentoverlayinput").val() / thisGC.config.overlay.unitMultiplier : null);
        thisGC.setColorScaleDomain();
      });

      // enter key is equivalent to click
      parametersdiv.find(".maxoverlay .input, .minoverlay .input, .centeroverlay .input, .extentoverlay .input").keypress(function(e){
        if (e.which == 13) {
          $(this).find("button").trigger("click");
        }
      });


      /* Number of particules */
      var partnumbervaluediv = parametersdiv.find(".particlenumberslider").parent("div").find(".value");
      parametersdiv.find(".particlenumberslider").off();
      parametersdiv.find(".particlenumberslider").slider({
        value:thisGC.config.flow.npart,
        min: 100,
        max: 25000,
        create: function() {
          partnumbervaluediv.text( $( this ).slider( "value" ) );
        },
        slide: function( event, ui ) {
          partnumbervaluediv.text( ui.value );
          thisGC.config.flow.npart = ui.value;
          clearTimeout(thisGC.particuleNumberTimeout);
          thisGC.particuleNumberTimeout = setTimeout(function() {
            thisGC.globe.particles = new Particles(thisGC.globe,ui.value);
          },100);
        }
      });

      /* Max Age */

      parametersdiv.find(".particledispearslider").parent("div")
              .find("label").html("Max age: &nbsp;<span class=\"value\" style=\"font-weight:bold;\">"+(thisGC.config.flow.maxage * thisGC.config.flow.timestep).toFixed(2) + "yr"+"</span>");

      var maxagevaluediv = parametersdiv.find(".particledispearslider").parent("div").find(".value");
      parametersdiv.find(".particledispearslider").off();

      parametersdiv.find(".particledispearslider").slider({
        value: (thisGC.config.flow.maxage * thisGC.config.flow.timestep).toFixed(2) + " yr",
        min: 1,
        max: 500,
        step: 1,
        slide: function( event, ui ) {
          maxagevaluediv.text( (thisGC.config.flow.maxage * thisGC.config.flow.timestep).toFixed(2) + " yr" );
          thisGC.config.flow.maxage = ui.value;
          thisGC.globe.particles.initAll();
        }
      });

      /* Particle Tail */
      var parttailvaluediv = parametersdiv.find(".particletailslider").parent("div").find(".value");
      parametersdiv.find(".particletailslider").off();
      parametersdiv.find(".particletailslider").slider({
        value:thisGC.config.flow.particleTail,
        min: 0,
        max: 1,
        step: 0.01,
        create: function() {
          parttailvaluediv.text( $( this ).slider( "value" ) );
        },
        slide: function( event, ui ) {
          parttailvaluediv.text( ui.value );
          thisGC.config.flow.particleTail = ui.value;
        }
      });

      /* Particle Sizes */
      var partsizesvaluediv = parametersdiv.find(".particlesizeslider").parent("div").find(".value");
      parametersdiv.find(".particlesizeslider").off();
      parametersdiv.find(".particlesizeslider").slider({
        range:true,
        values:[thisGC.config.flow.minParticleSize,thisGC.config.flow.maxParticleSize],
        min: 1,
        max: 10,
        step: 1,
        create: function() {
          partsizesvaluediv.text( $( this ).slider( "values" ).join(" - ") );
        },
        slide: function( event, ui ) {
          partsizesvaluediv.text( ui.values.join(" - ") );
          thisGC.config.flow.minParticleSize = ui.values[0];
          thisGC.config.flow.maxParticleSize = ui.values[1];
          thisGC.drawColorLegends();
        }
      });

      /* Particle Time Step */
      var deltatvaluediv = parametersdiv.find(".particledeltatslider").parent("div").find(".value");
      var yrpersdiv = parametersdiv.find(".animationspeedslider").parent("div").find(".yrpers");
      parametersdiv.find(".particledeltatslider").off();

      parametersdiv.find(".particledeltatslider").slider({
        value: Math.log10(thisGC.config.flow.timestep),
        min: -5,
        max: 5,
        step: 0.01,
        create: function() {
          var value = Math.pow(10,$( this ).slider( "value" ));
          if (value < 1e-1 || value > 1e1) {
            deltatvaluediv.html( value.toExponential(2).replace(/e/g, "x10<sup>") + "</sup>"  + " yr");
          } else {
            deltatvaluediv.text( value.toFixed(2) + " yr");
          }
        },
        slide: function( event, ui ) {
          var value = Math.pow(10,ui.value);
          if (value < 1e-1 || value > 1e1) {
            deltatvaluediv.html( value.toExponential(2).replace(/e/g, "x10<sup>") + "</sup>" + " yr" );
          } else {
            deltatvaluediv.text( value.toFixed(2)  + " yr");
          }

          yrpersdiv.text( (thisGC.config.flow.fps * value).toFixed(1)  + " yr/s");
          maxagevaluediv.text( (thisGC.config.flow.maxage * value).toFixed(2) + " yr" );
          thisGC.config.flow.timestep = value;
        }
      });

      /* Animation Speed */
      //var animspeedvaluediv = parametersdiv.find(".animationspeedslider").parent("div").find(".value");
      parametersdiv.find(".animationspeedslider").off();
      parametersdiv.find(".animationspeedslider").slider({
        value: thisGC.config.flow.fps,
        min: 0,
        max: 30,
        step: 0.01,
        create: function() {
          var fps = $( this ).slider( "value" );
          //animspeedvaluediv.text( fps );
          yrpersdiv.text( (fps * thisGC.config.flow.timestep).toFixed(1)  + " yr/s");
        },
        slide: function( event, ui ) {
          var fps = ui.value;
          //animspeedvaluediv.text( fps );
          yrpersdiv.text( (fps * thisGC.config.flow.timestep).toFixed(1) + " yr/s");
          thisGC.config.flow.fps = fps;
          if (thisGC.config.flow.show) {
            thisGC.globe.animateFlow(false);
          }
        }
      });

      /* List Flow Color Scales Gradient */
      parametersdiv.find(".flowcolorscaledropdown").find(".menu").empty();
      for (var colorScaleName in earthcorevisu.colorScales.svgGradientsFlow) {
        var dropdownitemhtml = "<div class=\"item\" data-value=\"" + colorScaleName + "\">" +
                                earthcorevisu.colorScales.svgGradientsFlow[colorScaleName].outerHTML
                                .replace(new RegExp("linear-gradientflow-", "g"), "linear-gradientflow-"+thisGC.name + "-"); +
                                "</div>";
        parametersdiv.find(".flowcolorscaledropdown").find(".menu").append(dropdownitemhtml);
      }
      parametersdiv.find(".flowcolorscaledropdown")
        .dropdown("set selected",thisGC.config.flow.colorScale)
        .dropdown({
          onChange:function(value){
            if (value in earthcorevisu.colorScales.scales) {
              $(this).find(".text").find("linearGradient").attr("id","linear-gradientflow-"+thisGC.name+"-selected");
              $(this).find(".text").find("rect").attr("fill","url(#linear-gradientflow-"+thisGC.name+"-selected)");
            }
            thisGC.setFlowColorScale(value);
            thisGC.showParameters();
          }
        });

      /* Flow Color Scales Data */
      parametersdiv.find(".flowcolorscaledatadropdown").find(".menu").empty();
      for (var data of [[0,"&theta;"],[1,"&Phi;"],[2,"Norm"]]) {
        var dropdownitemhtml = "<div class=\"item\" data-value=\"" + data[0] + "\">"+data[1]+"</div>";
        parametersdiv.find(".flowcolorscaledatadropdown").find(".menu").append(dropdownitemhtml);
      }
      parametersdiv.find(".flowcolorscaledatadropdown")
        .dropdown("set selected",thisGC.config.flow.colorScaleData)
        .dropdown({
          onChange:function(value){
            thisGC.config.flow.colorScaleData = +value;
            thisGC.setFlowColorScale(thisGC.config.flow.colorScale);
          }
        });

        /* Flow Color Scale limits */
        parametersdiv.find(".minflow.checkbox").checkbox({
          onChange: function(){
            var checked = parametersdiv.find(".minflow.checkbox").checkbox("is checked");
            thisGC.manualMinColorFlow = checked;
            parametersdiv.find(".minflow .input").toggleClass("disabled",!checked);
            thisGC.config.flow.min = (checked ? +parametersdiv.find(".minflowinput").val() / thisGC.config.flow.unitMultiplier : null);
            thisGC.setFlowColorScaleDomain();
          }
        }).checkbox("set " + (thisGC.manualMinColorFlow ? "checked" : "unchecked"));

        parametersdiv.find(".maxflow.checkbox").checkbox({
          onChange: function(){
            var checked = parametersdiv.find(".maxflow.checkbox").checkbox("is checked");
            thisGC.manualMaxColorFlow = checked;
            parametersdiv.find(".maxflow .input").toggleClass("disabled",!checked);
            thisGC.config.flow.max = (checked ? +parametersdiv.find(".maxflowinput").val() / thisGC.config.flow.unitMultiplier : null);
            thisGC.setFlowColorScaleDomain();
          }
        }).checkbox("set " + (thisGC.manualMaxColorFlow ? "checked" : "unchecked"));

        parametersdiv.find(".minflow .input .button").click(function(){
          var minColorFlow = +parametersdiv.find(".minflowinput").val() / thisGC.config.flow.unitMultiplier;
          thisGC.config.flow.min = minColorFlow;
          thisGC.setFlowColorScaleDomain();
        });

        parametersdiv.find(".maxflow .input .button").click(function(){
          var maxColorFlow = +parametersdiv.find(".maxflowinput").val() / thisGC.config.flow.unitMultiplier;
          thisGC.config.flow.max = maxColorFlow;
          thisGC.setFlowColorScaleDomain();
        });

        parametersdiv.find(".centerflow.checkbox").checkbox({
          onChange: function(){
            var checked = parametersdiv.find(".centerflow.checkbox").checkbox("is checked");
            thisGC.manualCenterColorFlow = checked;
            parametersdiv.find(".centerflow .input").toggleClass("disabled",!checked);
            thisGC.config.flow.center = (checked ? +parametersdiv.find(".centerflowinput").val() / thisGC.config.flow.unitMultiplier : null);
            parametersdiv.find(".centerflow .input .button").trigger("click");
          }
        }).checkbox("set " + (thisGC.manualCenterColorFlow ? "checked" : "unchecked"));

        parametersdiv.find(".extentflow.checkbox").checkbox({
          onChange: function(){
            var checked = parametersdiv.find(".extentflow.checkbox").checkbox("is checked");
            thisGC.manualExtentColorFlow = checked;
            parametersdiv.find(".extentflow .input").toggleClass("disabled",!checked);
            thisGC.config.flow.extent = (checked ? +parametersdiv.find(".extentflowinput").val() / thisGC.config.flow.unitMultiplier : null);
            parametersdiv.find(".extentflow .input .button").trigger("click");
          }
        }).checkbox("set " + (thisGC.manualExtentColorFlow ? "checked" : "unchecked"));

        parametersdiv.find(".centerflow .input .button, .extentflow .input .button").click(function(){
          thisGC.config.flow.center = (thisGC.manualCenterColorFlow ? +parametersdiv.find(".centerflowinput").val() / thisGC.config.flow.unitMultiplier : null);
          thisGC.config.flow.extent = (thisGC.manualExtentColorFlow ? +parametersdiv.find(".extentflowinput").val() / thisGC.config.flow.unitMultiplier : null);
          thisGC.setFlowColorScaleDomain();
        });

      // enter key is equivalent to click
      parametersdiv.find(".maxflow .input, .minflow .input, .centerflow .input, .extentflow .input").keypress(function(e){
        if (e.which == 13) {
          $(this).find("button").trigger("click");
        }
      });

      /* Invert Color Scale checkbox */
      parametersdiv.find(".invertcolorscale.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".invertcolorscale.checkbox").checkbox("is checked");
          thisGC.config.overlay.colorScaleInvert = checked;
          thisGC.setColorScale(thisGC.config.overlay.colorScale);
        }
      }).checkbox("set " + (thisGC.config.overlay.colorScaleInvert ? "checked" : "unchecked"));

      /* Invert Flow Color Scale checkbox */
      parametersdiv.find(".invertflowcolorscale.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".invertflowcolorscale.checkbox").checkbox("is checked");
          thisGC.config.flow.colorScaleInvert = checked;
          thisGC.setFlowColorScale(thisGC.config.flow.colorScale);
        }
      }).checkbox("set " + (thisGC.config.flow.colorScaleInvert ? "checked" : "unchecked"));

      /* Log Color Scale checkbox */
      parametersdiv.find(".logcolorscale.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".logcolorscale.checkbox").checkbox("is checked");
          thisGC.config.overlay.logColors = checked;
          thisGC.setColorScale(thisGC.config.overlay.colorScale);
        }
      }).checkbox("set " + (thisGC.config.overlay.logColors ? "checked" : "unchecked"));

      /* Log Flow Color Scale checkbox */
      parametersdiv.find(".logflowcolorscale.checkbox").checkbox({
        onChange: function(){
          var checked = parametersdiv.find(".logflowcolorscale.checkbox").checkbox("is checked");
          thisGC.config.flow.logColors = checked;
          thisGC.setFlowColorScale(thisGC.config.flow.colorScale);
        }
      }).checkbox("set " + (thisGC.config.flow.colorScalelog ? "checked" : "unchecked"));

      /* List Projections */
      parametersdiv.find(".projectiondropdown").find(".menu").empty();
      for (var ProjectionName in globeProjections()) {
        var projectionitemhtml = "<div class=\"item\" data-value=\"" + ProjectionName + "\">" + ProjectionName + "</div>";
        parametersdiv.find(".projectiondropdown").find(".menu").append(projectionitemhtml);
      }
      parametersdiv.find(".projectiondropdown")
        .dropdown("set selected",thisGC.config.projectionName)
        .dropdown({
          onChange:function(value){
            thisGC.globe.clearFlow();
            thisGC.globe.clearOverlay(true);

            thisGC.config.projectionName = value;
            thisGC.globe.initGlobe();

            setTimeout(function() {
              thisGC.globe.drawMap(true);
            },200);

          }
        });

      thisGC.initParam = true;
    }

    if (thisGC.config.flow.data) {
      parametersdiv.find(".showparticle").parent('.title').removeClass('disabled');
      parametersdiv.find(".particlenumberslider").slider("value",thisGC.config.flow.npart);
      parametersdiv.find(".particledispearslider").slider("value",thisGC.config.flow.maxage);
      parametersdiv.find(".particledeltatslider").slider("value",Math.log10(thisGC.config.flow.timestep));
      parametersdiv.find(".animationspeedslider").slider("value",thisGC.config.flow.fps);

      if (thisGC.config.flow.colorScale.startsWith('Div')) {
        parametersdiv.find(".centerflow").parents('.fields').show();
        parametersdiv.find(".minflow").parents('.fields').hide();
        parametersdiv.find(".centerflowinput").val(
          d3Format.format(".3")(
            (thisGC.manualCenterColorFlow ? thisGC.config.flow.center : 0 ) * thisGC.config.flow.unitMultiplier )
          );
        parametersdiv.find(".extentflowinput").val(
          d3Format.format(".3")(
            (thisGC.manualExtentColorFlow ? thisGC.config.flow.extent : Math.max(thisGC.config.flow.data.max[thisGC.config.flow.colorScaleData],-thisGC.config.flow.data.min[thisGC.config.flow.colorScaleData])) *
            thisGC.config.flow.unitMultiplier )
          );
        parametersdiv.find(".centerflow .input").toggleClass("disabled" , !thisGC.manualCenterColorFlow);
        parametersdiv.find(".extentflow .input").toggleClass("disabled" , !thisGC.manualExtentColorFlow);
        parametersdiv.find('.centerflow.checkbox label').html("Center (" + thisGC.config.flow.unit + ")");
        parametersdiv.find('.extentflow.checkbox label').html("Extent (" + thisGC.config.flow.unit + ")");
        parametersdiv.find(".centerflow.checkbox").checkbox("set " + (thisGC.manualCenterColorFlow ? "checked" : "unchecked"));
        parametersdiv.find(".extentflow.checkbox").checkbox("set " + (thisGC.manualExtentColorFlow ? "checked" : "unchecked"));
      }
      else {
        parametersdiv.find(".centerflow").parents('.fields').hide();
        parametersdiv.find(".minflow").parents('.fields').show();
        parametersdiv.find(".minflowinput").val(
          d3Format.format(".3")(
            (thisGC.manualMinColorFlow ? thisGC.config.flow.min : thisGC.config.flow.data.min[thisGC.config.flow.colorScaleData].toFixed(3)) *
             thisGC.config.flow.unitMultiplier )
          );
        parametersdiv.find(".maxflowinput").val(
          d3Format.format(".3")(
            (thisGC.manualMaxColorFlow ? thisGC.config.flow.max : thisGC.config.flow.data.max[thisGC.config.flow.colorScaleData].toFixed(3)) *
            thisGC.config.flow.unitMultiplier )
          );
        parametersdiv.find(".minflow .input").toggleClass("disabled" , !thisGC.manualMinColorFlow);
        parametersdiv.find(".maxflow .input").toggleClass("disabled" , !thisGC.manualMaxColorFlow);
        parametersdiv.find('.minflow.checkbox label').html("Min (" + thisGC.config.flow.unit + ")");
        parametersdiv.find('.maxflow.checkbox label').html("Max (" + thisGC.config.flow.unit + ")");
        parametersdiv.find(".minflow.checkbox").checkbox("set " + (thisGC.manualMinColorFlow ? "checked" : "unchecked"));
        parametersdiv.find(".maxflow.checkbox").checkbox("set " + (thisGC.manualMaxColorFlow ? "checked" : "unchecked"));
      }
    } else {
      parametersdiv.find(".showparticle").parent('.title').addClass('disabled');
    }

    if (thisGC.config.overlay.data) {
      parametersdiv.find(".showoverlay").parent('.title').removeClass('disabled');
      if (thisGC.config.overlay.colorScale.startsWith('Div')) {
        parametersdiv.find(".centeroverlay").parents('.fields').show();
        parametersdiv.find(".minoverlay").parents('.fields').hide();
        parametersdiv.find(".centeroverlayinput").val(
          d3Format.format(".3")(
            (thisGC.manualCenterOverlay ? thisGC.config.overlay.center : 0 ) *
            thisGC.config.overlay.unitMultiplier )
          );
        parametersdiv.find(".extentoverlayinput").val(
          d3Format.format(".3")(
            (thisGC.manualExtentOverlay ? thisGC.config.overlay.extent : Math.max(thisGC.config.overlay.data.magmax,-thisGC.config.overlay.data.magmin).toFixed(3)) *
            thisGC.config.overlay.unitMultiplier )
          );
        parametersdiv.find(".centeroverlay .input").toggleClass("disabled" , !thisGC.manualCenterOverlay);
        parametersdiv.find(".extentoverlay .input").toggleClass("disabled" , !thisGC.manualExtentOverlay);
        parametersdiv.find('.centeroverlay.checkbox label').html("Center (" + thisGC.config.overlay.unit + ")");
        parametersdiv.find('.extentoverlay.checkbox label').html("Extent (" + thisGC.config.overlay.unit + ")");
        parametersdiv.find(".centeroverlay.checkbox").checkbox("set " + (thisGC.manualCenterOverlay ? "checked" : "unchecked"));
        parametersdiv.find(".extentoverlay.checkbox").checkbox("set " + (thisGC.manualExtentOverlay ? "checked" : "unchecked"));
      }
      else {
        parametersdiv.find(".centeroverlay").parents('.fields').hide();
        parametersdiv.find(".minoverlay").parents('.fields').show();
        parametersdiv.find(".minoverlayinput").val(
          d3Format.format(".3")(
            (thisGC.manualMinOverlay ? thisGC.config.overlay.min : thisGC.config.overlay.data.magmin.toFixed(3)) *
            thisGC.config.overlay.unitMultiplier )
          );
        parametersdiv.find(".maxoverlayinput").val(
          d3Format.format(".3")(
            (thisGC.manualMaxOverlay ? thisGC.config.overlay.max : thisGC.config.overlay.data.magmax.toFixed(3)) *
            thisGC.config.overlay.unitMultiplier )
          );
        parametersdiv.find(".minoverlay .input").toggleClass("disabled" , !thisGC.manualMinOverlay);
        parametersdiv.find(".maxoverlay .input").toggleClass("disabled" , !thisGC.manualMaxOverlay);
        parametersdiv.find('.minoverlay.checkbox label').html("Min (" + thisGC.config.overlay.unit + ")");
        parametersdiv.find('.maxoverlay.checkbox label').html("Max (" + thisGC.config.overlay.unit + ")");
        parametersdiv.find(".minoverlay.checkbox").checkbox("set " + (thisGC.manualMinOverlay ? "checked" : "unchecked"));
        parametersdiv.find(".maxoverlay.checkbox").checkbox("set " + (thisGC.manualMaxOverlay ? "checked" : "unchecked"));
      }

    } else {
      parametersdiv.find(".showoverlay").parent('.title').addClass('disabled');
    }

    parametersdiv.find(".animationdurationslider").slider("value",thisGC.videoDuration);


    /* Show div */
    parametersdiv.show();
    parametersdiv.find(".close").click(function () {
      parametersdiv.hide();
    });
  }


  // DRAW LEGENDS
  drawColorLegends() {
    this.clearColorLegends();
    if (this.config.overlay.show) {
      this.drawColorLegend("overlay");
    }
    if (this.config.flow.show) {
      this.drawColorLegend("colorflow");
    }
  }

  drawColorLegend(mode="overlay") {
    var legendContext = this.globe.legendContext;

    // Define Sizes
    var titleHeight = 1*rem();
    if (mode == "overlay" && this.config.overlay.title) {  titleHeight += 1*rem(); }
    if (mode == "overlay" && this.config.overlay.unit)  {  titleHeight += 1*rem(); }
    if (mode == "colorflow" && this.config.flow.title) {  titleHeight += 1*rem(); }
    if (mode == "colorflow" && this.config.flow.unit)  {  titleHeight += 1*rem(); }
    if (this.config.title)  {  titleHeight = 3*rem(); }
    if (this.config.subtitle)  {  titleHeight += 1.5*rem(); }

    var boxheight = this.height - 2*rem() - titleHeight;
    var boxwidth = 1*rem();
    var legendx = 1*rem();
    if (mode == "colorflow") {
      legendx = this.width - 2.5*rem();
    }
    var legendy = titleHeight;

    var scale = this.globe.colorScale;
    if (mode == "colorflow") {
      scale = this.globe.flowColorScale;
    }


    // Create ticks and measure corresponding text width
    var tickNumber = Math.min(10,Math.round(boxheight/(5*rem())));
    var ticks = scale.scale.ticks(tickNumber);
    legendContext.font = rem() + "px Lato";
    var maxTextWidth = 0;

    //determine min precision needed in legend ticks
    var eprecision = 0;
    var fixedprecision = 0;
    for (var itick in ticks) {
      ticks[itick] *= (mode == "colorflow" ? this.config.flow.unitMultiplier : this.config.overlay.unitMultiplier);
      for (eprecision; eprecision<=5; eprecision++) {
        if ( +d3Format.format("."+fixedprecision+"e")(ticks[itick]) == +d3Format.format(".5e")(ticks[itick])) {
          break;
        }
      }
      for (fixedprecision; fixedprecision<=5; fixedprecision++) {
        if ( +d3Format.format("."+fixedprecision+"f")(ticks[itick]) == +d3Format.format(".5f")(ticks[itick])) {
          break;
        }
      }
    }
    console.log("fixedprecision",fixedprecision);
    console.log("eprecision",eprecision);


    var tickstext = $.extend( true, {}, ticks );
    for (var itick in ticks) {
      if (ticks[itick]==0) {
        tickstext[itick] = "0";
      } else if (Math.abs(ticks[itick])<1000 && Math.abs(ticks[itick])>0.001) {
        tickstext[itick] = ticks[itick].toFixed(fixedprecision);
      } else {
        tickstext[itick] = ticks[itick].toExponential(eprecision);
      }
      maxTextWidth = Math.max(legendContext.measureText(tickstext[itick]).width,maxTextWidth);
    }
    console.log(tickstext)


    // Draw transparent background box
    legendContext.fillStyle = "rgba(255,255,255,0.5)";
    if (mode == "overlay" || !this.config.overlay.show) {
      legendContext.fillRect(0,0,this.width/2,titleHeight);
    }
    if (mode == "colorflow" || !(this.config.flow.show)) {
      legendContext.fillRect(this.width/2,0,this.width/2,titleHeight);
    }
    if (mode == "overlay") {
      legendContext.fillRect(0,titleHeight,boxwidth+legendx+maxTextWidth+1*rem(),this.height);
    }
    if (mode == "colorflow") {
      legendContext.fillRect(legendx-boxwidth-maxTextWidth-1*rem(),titleHeight,this.width,this.height);
    }

    // Draw Legend unit/title
    legendContext.fillStyle = "rgba(0,0,0,0.8)";
    if (mode == "overlay") {
      legendContext.textAlign="left";
      if (this.config.overlay.title) {
        legendContext.font = "bold " + rem() + "px Lato";
        legendContext.fillText(this.config.overlay.title, legendx, 1.5*rem());
      }
      if (this.config.overlay.unit) {
        legendContext.font = "italic " + rem() + "px Lato";
        legendContext.fillText("("+this.config.overlay.unit+")", legendx, 1.5*rem() + (this.config.overlay.title?rem():0));
      }
    }
    if (mode == "colorflow") {
      legendContext.textAlign="right";
      if (this.config.flow.title) {
        var flowtitle = this.config.flow.title
        if (this.config.flow.colorScaleData == 0) {
          flowtitle = this.config.flow.title+"θ";
        } if (this.config.flow.colorScaleData == 1) {
          flowtitle = this.config.flow.title+"ϕ";
        } if (this.config.flow.colorScaleData == 2) {
          flowtitle = "‖"+this.config.flow.title+"‖";
        }

        legendContext.font = "bold " + rem() + "px Lato";
        legendContext.fillText(flowtitle, legendx + boxwidth, 1.5*rem());
      }
      if (this.config.flow.unit) {
        legendContext.font = "italic " + rem() + "px Lato";
        legendContext.fillText("("+this.config.flow.unit+")", legendx + boxwidth, 1.5*rem() + (this.config.overlay.title?rem():0));
      }
    }
    if (this.config.title) {
      legendContext.textAlign="center";
      legendContext.font = "bold " + 1.25*rem() + "px Lato";
      legendContext.fillText(this.config.title, this.width/2, 2*rem());
    }
    if (this.config.subtitle) {
      legendContext.textAlign="center";
      legendContext.font = 1.1*rem() + "px Lato";
      legendContext.fillText(this.config.subtitle, this.width/2, 3.5*rem());
    }



    // Draw gradient box
    if ((mode == "overlay") || (!scale.allSameColors)){
      var grd=legendContext.createLinearGradient(legendx,legendy,legendx,legendy+boxheight);
      var scaleLength = scale.scale.domain().length;
      var scaleExtend = scale.scale.domain()[scaleLength-1] - scale.scale.domain()[0]
      for (var stop=0; stop<scaleLength; stop++) {
        grd.addColorStop(1-(1/scaleExtend*(scale.scale.domain()[stop] - scale.scale.domain()[0])),
                        "rgb("+scale.scale(scale.scale.domain()[stop]).join(",")+")");
      }
      legendContext.fillStyle = grd;
      legendContext.strokeStyle = "rgba(0,0,0,1)";
      legendContext.lineWidth = 1;

      legendContext.beginPath();

      legendContext.moveTo(legendx,legendy);
      legendContext.lineTo(legendx,legendy + boxheight);
      legendContext.lineTo(legendx + boxwidth,legendy + boxheight);
      legendContext.lineTo(legendx + boxwidth,legendy);

      legendContext.closePath();
      legendContext.fill();
      legendContext.stroke();
    }
    if (mode == "colorflow"){
      //DISPLAYS PARTICLE SIZE ON LEGEND
      legendContext.fillStyle = "rgba(0,0,0,1)";
      legendContext.lineWidth = 1;

      var progresses = linspace(0,1,Math.floor(boxheight/10));
      for (var progress of progresses){
        var partsize = this.config.flow.minParticleSize + progress * (this.config.flow.maxParticleSize - this.config.flow.minParticleSize);
        var ypos = legendy + (1-progress) * boxheight;
        var xpos = (scale.allSameColors ? legendx + boxwidth/2 : legendx + boxwidth + this.config.flow.maxParticleSize)
        legendContext.beginPath();
        legendContext.arc(xpos, ypos, partsize/2, 0, 2 * Math.PI, false);
        legendContext.fill();
      }
    }

    // Draw ticks and ticks text
    legendContext.fillStyle = "rgba(0,0,0,0.8)";
    legendContext.strokeStyle = "rgba(0,0,0,0.5)";
    legendContext.font = rem() + "px Lato";
    for (var itick in ticks) {
      var progress = (scale.max - ticks[itick] / (mode == "colorflow" ? this.config.flow.unitMultiplier : this.config.overlay.unitMultiplier)) / (scale.max - scale.min);
      var ypos = legendy + progress * boxheight;
      if (ypos > this.height) {continue;}
      if (ypos < legendy) {continue;}
      if (mode == "overlay") {
        legendContext.textAlign="left";
        legendContext.fillText(tickstext[itick],
            legendx + boxwidth + 0.5*rem(),
            ypos + 0.25*rem());
        legendContext.beginPath();
        legendContext.moveTo(legendx,ypos);
        legendContext.lineTo(legendx + boxwidth + 0.25*rem(),ypos);
        legendContext.stroke();
      }
      if (mode == "colorflow") {
        legendContext.textAlign="right";
        legendContext.fillText(tickstext[itick],
            legendx - 0.5*rem(),
            ypos + 0.25*rem());
        legendContext.beginPath();
        if (scale.allSameColors) {
          legendContext.moveTo(legendx - 0.25*rem(),ypos);
          legendContext.lineTo(legendx + boxwidth/2,ypos);
        } else {
          legendContext.moveTo(legendx - 0.25*rem(),ypos);
          legendContext.lineTo(legendx + boxwidth/2,ypos);
        }
        legendContext.stroke();
      }
    }


    /*
      //DISPLAYS PARTICLE SIZE ON LEGEND
      legendContext.fillStyle = grd;
      legendContext.strokeStyle = "rgba(0,0,0,0.8)";
      legendContext.lineWidth = 0.5;
      for (var progress=0; progress<=1; progress+=0.01) {
        var ypos = legendy + (1-progress) * boxheight;
        var xpos = legendx + boxwidth + 0.5*rem();
        legendContext.beginPath();
        var diameter = this.config.flow.minParticleSize + progress *
                    (this.config.flow.maxParticleSize - this.config.flow.minParticleSize);
        legendContext.arc(xpos, ypos, diameter/2 , 0, 2 * Math.PI, false);
        legendContext.fill();
      }
    }*/

  }

  clearColorLegends() {
    this.globe.legendContext.clearRect(0,0,this.width,this.height);
  }

  /**********************************************/
  /** Redirection to important globe functions  */
  /**********************************************/

  setOverlayData(scalarOrVectorData,draw) {
    return new Promise((resolve, reject) => {
      if (this.config.overlay.data == null && scalarOrVectorData != null) {
        this.config.overlay.show = true;
      }
      if (scalarOrVectorData == null) {
        this.config.overlay.show = false;
      }
      this.config.overlay.data = scalarOrVectorData;
      this.setColorScaleDomain(draw)
        .then(resolve)
        .catch(reject);
    });
  }

  setColorScale(colorscale, invert=null, logColors=null, draw=true) {
    this.config.overlay.colorScale = colorscale;
    this.config.overlay.colorScaleInvert = (invert == null ? this.config.overlay.colorScaleInvert : invert);
    this.config.overlay.logColors = (logColors == null ? this.config.overlay.logColors : logColors);
    this.globe.setColorScale(this.config.overlay.colorScale, this.config.overlay.colorScaleInvert, this.config.overlay.logColors, false);
    this.setColorScaleDomain(draw);
    this.drawColorLegends();
  }

  setFlowColorScale(colorscale, invert=null, logColors=null, draw=true) {
    this.config.flow.colorScale = colorscale;
    this.config.flow.colorScaleInvert = (invert == null ? this.config.flow.colorScaleInvert : invert);
    this.config.flow.logColors = (logColors == null ? this.config.flow.logColors : logColors);
    this.globe.setFlowColorScale(this.config.flow.colorScale, this.config.flow.colorScaleInvert, this.config.flow.logColors, false);
    this.setFlowColorScaleDomain(draw);
    this.drawColorLegends();
  }

  setFlowData(vectorData,draw=true) {
    if (this.config.flow.data == null && vectorData != null) {
      this.config.flow.show = true;
    }
    if (vectorData == null) {
      this.config.flow.show = false;
    }
    this.config.flow.data = vectorData;
    if (draw && this.config.flow.show && vectorData != null) {
      this.globe.animateFlow();
    }
    this.setFlowColorScaleDomain(draw);
  }

  setColorScaleDomain(draw=true){
    return new Promise((resolve, reject) => {
    if (!this.config.overlay.data) {resolve(); return;}

      if (this.config.overlay.colorScale.startsWith('Div')) {
        var centerOverlay = (this.manualCenterOverlay ? this.config.overlay.center : 0 );
        var extentOverlay =  (this.manualExtentOverlay ? this.config.overlay.extent : Math.max(this.config.overlay.data.magmax,-this.config.overlay.data.magmin));
        console.log('SET CENTER EXTENT',centerOverlay,extentOverlay);
        this.globe.colorScale.setDomain([centerOverlay-extentOverlay,centerOverlay+extentOverlay]);
      }
      else {
        var minOverlay = (this.manualMinOverlay ? this.config.overlay.min : this.config.overlay.data.magmin );
        var maxOverlay =  (this.manualMaxOverlay ? this.config.overlay.max : this.config.overlay.data.magmax);
        console.log('SET MIN MAX',minOverlay,maxOverlay);
        this.globe.colorScale.setDomain([minOverlay,maxOverlay]);
      }

      //this.config.overlay.min = minOverlay;
      //this.config.overlay.max = maxOverlay;
      this.drawColorLegends();
      if (draw) {
        this.globe.doDrawMap(false,false,false,false)
          .then(resolve)
          .catch(reject);
      } else { resolve();}

    });
  }

  setFlowColorScaleDomain(draw=true){
    if (!this.config.flow.data) {return;}

    if (this.config.flow.colorScale.startsWith('Div')) {
      var centerColorFlow = (this.manualCenterColorFlow ? this.config.flow.center : 0 );
      var extentColorFlow =  (this.manualExtentColorFlow ? this.config.flow.extent : Math.max(this.config.flow.data.max[this.config.flow.colorScaleData],-this.config.flow.data.min[this.config.flow.colorScaleData]));
      console.log('SET CENTER EXTENT',centerColorFlow,extentColorFlow);
      this.globe.flowColorScale.setDomain([centerColorFlow-extentColorFlow,centerColorFlow+extentColorFlow]);
    }
    else {
      var minColorFlow = (this.manualMinColorFlow ? this.config.flow.min : this.config.flow.data.min[this.config.flow.colorScaleData] );
      var maxColorFlow =  (this.manualMaxColorFlow ? this.config.flow.max : this.config.flow.data.max[this.config.flow.colorScaleData] );
      console.log('SET MIN MAX',minColorFlow,maxColorFlow);
      this.globe.flowColorScale.setDomain([minColorFlow,maxColorFlow]);
    }

    this.drawColorLegends();
    if (draw) {
      this.globe.drawMap(true);
    }
  }

  updateSteps() {
    let a = $('.meridianstepslider').slider("value");
    let b = $('.parallelstepslider').slider("value");
    this.globe.setGraticuleSteps(a, b);
  }

}



//////////////////
// WEBPACK FOOTER
// ./src/controller/globeController.js
// module id = 13
// module chunks = 0